import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row, Button, Form } from 'react-bootstrap';
import { Context } from '../Components/Context';
import HfDateInput from '../Components/shared/HfDateInput';
import ApplicantInfo from '../Components/ApplicantInfo';

const Intake = () => {
    const { applicants, setApplicants, defaultApplicant, counties, effectiveDate, setEffectiveDate, selectedCounty, setSelectedCounty } = useContext(Context);
    const [validated, setValidated] = useState(false);
    const [showApplicantError, setShowApplicantError] = useState(false);

    const navigate = useNavigate();

    const setApplicantProperty = (id, prop, value) => {
        let modified = applicants.find(applicant => applicant.id === id);
        if (!modified) {
            console.warn('setApplicantProperty: no applicant found for id', id);
            return;
        } else {
            // Set the property
            modified = { ...modified, [prop]: value };
        }

        setApplicants(applicants.map(applicant =>
            applicant.id === id ? modified : applicant
        ));
    }

    const addApplicant = ({ type }) => {
        // Get the next id. Default to 0 if no applicants exist
        let newId = applicants.length ? applicants.reduce((prev, current) => current.id > prev.id ? current : prev).id + 1 : 0;
        setApplicants([...applicants, { ...defaultApplicant, id: newId, type: type }]);

        if (applicants.filter(applicant => applicant.type === 'Primary').length === 0 || type == 'Primary') {
            setShowApplicantError(false);
        }
    }

    const removeApplicant = (id) => {
        setApplicants(applicants.filter(applicant => applicant.id !== id));
    }

    let minEffectiveDate = new Date(new Date().getFullYear(), 0, 1).toLocaleDateString('sv'); // Jan 1 of this year
    let maxEffectiveDate = new Date(new Date().getFullYear() + 1, 11, 31).toLocaleDateString('sv'); // Dec 31 of next year

    const typeMap = {
        'Primary': 0,
        'Spouse': 1,
        'Dependent': 2
    };

    const sortByTypeThenId = (a, b) => {
        if (typeMap[a.type] < typeMap[b.type]) {
            return -1;
        } else if (typeMap[a.type] > typeMap[b.type]) {
            return 1;
        } else {
            return a.id - b.id;
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let form = document.forms[0];
        let formIsValid = form.checkValidity();

        if (applicants.filter(applicant => applicant.type === 'Primary').length === 0) {
            setShowApplicantError(true);
            formIsValid = false;
        }

        if (!formIsValid) {
            console.log('forminvalid');

            // Turn on validation status
            setValidated(true);

            // Scroll to first invalid element
            let elements = [...document.querySelectorAll('input,select,textarea')].reverse();

            for (var i = elements.length; i--;) {
                if (elements[i].id) {
                    let elem = document.getElementById(elements[i].id);

                    if (elem.validity.valid === false) {
                        elem.scrollIntoView({ behavior: 'smooth' });
                        break;
                    }
                }
            }
        }
        else {
            // All required fields are complete
            navigate('/PlanSelect');
        }
    }

    return (
        <section className='survey-forms'>
            <Form id="enrollmentform" noValidate validated={validated} onSubmit={handleSubmit}>
                <Container className='d-grid gap-3 mt-3'>
                    <Row>
                        <Col>
                            <Container className='d-grid gap-3'>
                                <h2 className="mb-2">Intake</h2>
                            </Container>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={5} lg={6} md={8} sm={12} className="border-end">
                            <Container className='d-grid gap-3'>
                                <Row>
                                    <Col>
                                        <Form.Group controlId="primaryCounty">
                                            <Form.Label>County *</Form.Label>
                                            <Form.Select value={selectedCounty} onChange={(e) => { setSelectedCounty(e.target.value) }} required>
                                                <option hidden value="">Select County</option>
                                                {counties.map((county) =>
                                                    <option value={county} key={county}>{county}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group controlId='effective-date'>
                                            <Form.Label>Requested effective date *</Form.Label>
                                            <HfDateInput value={effectiveDate} min={minEffectiveDate} max={maxEffectiveDate} onChange={(e) => { setEffectiveDate(e.target.value) }} required />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <h5>Please enter the applicant information</h5>
                                {applicants.sort(sortByTypeThenId).map((applicant, index) =>
                                    <Row key={applicant.id}>
                                        <Col>
                                            <ApplicantInfo applicant={applicant} handleChange={setApplicantProperty} handleDelete={removeApplicant} />
                                        </Col>
                                    </Row>
                                )}
                                {showApplicantError && <Row><Col><div className="invalid-feedback d-block fs-5">You must have a primary applicant to proceed.</div></Col></Row>}
                                {applicants.filter(applicant => applicant.type === 'Primary').length === 0 &&
                                    <Row>
                                        <Col>
                                            <Button variant="outline-primary" onClick={() => addApplicant({ type: 'Primary' })}>Add Primary Applicant</Button>
                                        </Col>
                                    </Row>
                                }
                                {applicants.filter(applicant => applicant.type === 'Spouse').length === 0 &&
                                    <Row>
                                        <Col>
                                            <Button variant="outline-primary" onClick={() => addApplicant({ type: 'Spouse' })}>Add Spouse Applicant</Button>
                                        </Col>
                                    </Row>
                                }
                                {applicants.filter(applicant => applicant.type === 'Dependent').length < 10 &&
                                    <Row>
                                        <Col>
                                            <Button variant="outline-primary" onClick={() => addApplicant({ type: 'Dependent' })}>Add Dependent Applicant</Button>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col>
                                        <Button onClick={handleSubmit}>Next</Button>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col className="ps-4">
                            <h6>Disclaimer</h6>
                            <p>Members enrolling in Off Marketplace plans are not eligible to receive any premium assistance. If you believe your client may qualify for Advanced Premium Tax Credit please review their options for an On Marketplace plan</p>
                            <h6>Open Enrollment</h6>
                            <p>Apply between November 1st - December 15th for a January 1st effective date.</p>
                            <p>Apply between December 16th - January 15th for a February 1st effective date.</p>
                            <h6>Special Enrollment Period</h6>
                            <p>Coverage is effective the first of the month following plan selection. For example, if a plan is selected on June 1, coverage would start on July 1.
                                For certain situations (such as birth), agents may request an earlier coverage effective date, specifically the coverage effective date your client would be eligible for.
                                Enrollments can only be accepted within 60 days of the requested effective date. Documentation may be required if enrolling due to a Qualifying Life Event.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </section>
    )
}

export default Intake;
